import React from 'react'
import { Typography } from 'antd'

const { Text, Title } = Typography

const STEPS = [
    'Save your Virtual Account details in your personal bank account as a beneficiary.',
    'Transfer funds from your bank account.',
    'Funds Reflected in Wallet',
    'Invest in available Invoice Financing deals.',
]

const InvestingSteps = () => {
    return (
        <div className='investing-steps-container'>
            <Title level={5} style={{ color: "#0D1A48", marginBottom: 20 }}>How to start Investing in deals?</Title>
            <div className='investing-steps-list'>
                {STEPS.map((stepText, index) => (
                    <div className='investing-step-row' key={index}>
                        <div className='investing-step-indicator'>
                            <div className='step'>{index + 1}</div>
                            {index < STEPS.length - 1 && <div className='steps-divider' />}
                        </div>
                        <Text className='investing-step-text'>{stepText}</Text>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default InvestingSteps
